import { useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Trash2, RotateCcw, Loader2 } from "lucide-react";
import { toast } from "sonner";

const LBL = { clients: "Client", vehicles: "Véhicule", appointments: "RDV" };

export default function Corbeille() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get("/trash"); setItems(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const restore = async (id) => { try { await api.post(`/trash/${id}/restore`); toast.success("Élément restauré"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };
  const purge = async (id) => { try { await api.delete(`/trash/${id}`); toast.success("Supprimé définitivement"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };

  return (
    <div>
      <PageHeader title="Corbeille" subtitle="Éléments supprimés — restaurables (hors factures)" icon={Trash2} />
      {loading ? <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div> : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid="trash-list">
          {items.length ? items.map((t) => (
            <div key={t.id} data-testid="trash-row" className="flex items-center justify-between gap-3 p-3 border-b border-slate-100 last:border-0">
              <div className="min-w-0">
                <div className="text-sm text-slate-900 truncate">{t.label} <span className="text-xs text-slate-400">· {LBL[t.entity] || t.entity}</span></div>
                <div className="text-xs text-slate-500">Supprimé le {new Date(t.deleted_at).toLocaleString("fr-FR")}{t.deleted_by ? ` par ${t.deleted_by}` : ""}</div>
              </div>
              <div className="flex gap-1.5 shrink-0">
                <Button size="sm" variant="outline" onClick={() => restore(t.id)} data-testid={`btn-restore-${t.id}`} className="h-8 border-emerald-200 text-emerald-700"><RotateCcw className="w-3.5 h-3.5 mr-1" />Restaurer</Button>
                <Button size="sm" variant="outline" onClick={() => purge(t.id)} className="h-8 border-red-200 text-red-600"><Trash2 className="w-3.5 h-3.5" /></Button>
              </div>
            </div>
          )) : <p className="text-sm text-slate-500 p-6 text-center">La corbeille est vide.</p>}
        </div>
      )}
    </div>
  );
}
